import choose_your_documents_json from './update-bank-account-choose-your-documents.json';
import main_dialog_json from './update-bank-account-modal.json';
import data_json from './update-bank-account-data.json';
import wealth_success_json from './update-bank-account-wealth-success.json';
import pocket_success_json from './update-bank-account-pocket-success.json';

export default {
  'update-bank-account': {
    ...choose_your_documents_json,
    ...main_dialog_json,
    ...data_json,
    ...wealth_success_json,
    ...pocket_success_json,
  },
};
